module.exports = "/_next/static/images/logo-aman-332bbd6611f442da59d82fcb70126796.svg";